import {ModuleRouteManifest} from '../types'

export const analyticsRouteManifest: ModuleRouteManifest = {
  code: 'analytics',
  privateRoutes: ['executive-report-dashboard', 'dynamic-report'],
}
